// components/TawkToWidget.tsx
import { useEffect, useRef } from 'react';

const TawkToWidget: React.FC = () => {
  console.log('TawkToWidget component mounted');
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    if (scriptLoadedRef.current) return; // prevent duplicate script loading
    scriptLoadedRef.current = true;

    const s1 = document.createElement('script');
    s1.src = 'https://embed.tawk.to/65cfabc18d261e1b5f617e9c/1hmpjdro9';
    s1.async = true;
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    s1.id = 'tawk-script';

    s1.onload = () => {
      console.log('Tawk.to script loaded');
    };

    document.body.appendChild(s1);
  }, []);

  return null;
};

export default TawkToWidget;
